var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_menu_type_3"),
        visible: _vm.visible,
        size: "480px",
        direction: "rtl",
      },
      on: { close: _vm.handleCancel },
    },
    [
      _c(
        "yxt-form",
        {
          ref: "refForm",
          staticClass: "form-box",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "is-need-require": "",
            "is-need-tooltip": "",
          },
        },
        [
          _c(
            "yxt-form-item",
            { attrs: { label: _vm.$t("pc_l_select_role"), prop: "roles" } },
            [
              _c("yxt-select", {
                attrs: {
                  multiple: "",
                  placeholder: _vm.$t("pc_select_placeholder"),
                  "icon-name": "more",
                  "hidden-option": "",
                  "collapse-tags": "",
                  "value-key": "id",
                  "prop-label": "fullname",
                },
                on: {
                  change: function ($event) {
                    _vm.formData.auditType = 0
                  },
                  "visible-change": function ($event) {
                    _vm.dialogVisible = true
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "tag",
                    fn: function (ref) {
                      var data = ref.data
                      return [
                        _c("yxtbiz-user-name", {
                          attrs: { name: data.currentLabel },
                        }),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.formData.roles,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "roles", $$v)
                  },
                  expression: "formData.roles",
                },
              }),
            ],
            1
          ),
          _vm.formData.roles.length > 1
            ? _c(
                "yxt-form-item",
                {
                  staticClass: "sel-type-item",
                  attrs: { label: _vm.$t("pc_audit_multi") },
                },
                [
                  _c(
                    "yxt-radio-group",
                    {
                      model: {
                        value: _vm.formData.auditType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "auditType", $$v)
                        },
                        expression: "formData.auditType",
                      },
                    },
                    [
                      _c(
                        "yxt-radio",
                        { attrs: { label: 0 } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_audit_or")) +
                              "\n            "
                          ),
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("pc_audit_or_tip"),
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "ml4 color-gray-7",
                                attrs: {
                                  "icon-class": "question-cirlce-o",
                                  width: "16px",
                                  height: "16px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "yxt-radio",
                        { attrs: { label: 1 } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_audit_and")) +
                              "\n            "
                          ),
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("pc_audit_and_tip"),
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "ml4 color-gray-7",
                                attrs: {
                                  "icon-class": "question-cirlce-o",
                                  width: "16px",
                                  height: "16px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("pc_cancel_mini")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v(_vm._s(_vm.$t("pc_ok_mini")))]
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            "header-border": false,
            "destroy-on-close": true,
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxtbiz-range-selector", {
            ref: "selector",
            attrs: {
              selected: _vm.formData.roles,
              model: "array",
              tabs: ["persons", "advance"],
              "function-code": _vm.functionCode,
              "data-permission-code": _vm.dataPermissionCode,
            },
            on: {
              change: function ($event) {
                _vm.roles = $event
              },
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_cancel")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRolesOk },
                },
                [_vm._v(_vm._s(_vm.$t("pc_ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }